import { useCallback, useContext } from 'react';
import { ScopeContext } from '@bingads-webui-react/scope-service';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';
import { getCampaignPageUrl, getUrlForPath } from '@bingads-webui-campaign-react/shared-app-capi';
import { isSDK, isFirefoxSDKSignupScenario, getSDKParams } from '@bingads-webui-campaign-react/sdk-utils';

export const useSubmitToMainBundle = () => {
  const { scope } = useContext(ScopeContext);
  const { campaignId, assetGroupId } = scope.values;
  const serverContext = useContext(ServerContext);
  const isChinaSignup = usePilotsValue('isCNMarketExpansionEnabled');

  const submitToMainBundle = useCallback(({ goToUrl } = {}) => {
    let mainBundleUrl;
    if (isSDK()) {
      const { mkt } = getSDKParams();
      mainBundleUrl = getCampaignPageUrl(serverContext, 'sdkcampaignoverview', {
        campaignId,
        assetGroupId,
        isSDK: true,
        mkt,
      });

      // For firefox, we need to navigate to sdkintermediate who will call document.requestStorageAccess silently
      // to gain the storage permission of ui.ads.microsoft.com
      if (isFirefoxSDKSignupScenario()) {
        mainBundleUrl = getUrlForPath(serverContext, 'campaign/sdkintermediate', {
          RURL: mainBundleUrl,
        });
      }
    } else if (isChinaSignup) {
      mainBundleUrl = getCampaignPageUrl(serverContext, 'overview');
    } else {
      mainBundleUrl = campaignId
        ? getCampaignPageUrl(serverContext, 'overview', { campaignId })
        : getCampaignPageUrl(serverContext, 'createcampaign/objective');
    }
    if (goToUrl) {
      goToUrl(mainBundleUrl);
    } else {
      window.location.replace(mainBundleUrl);
    }
  }, [isChinaSignup, serverContext, campaignId, assetGroupId]);

  return submitToMainBundle;
};
